import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import { isLoggedIn } from '../../../helpers/securityHelper';
import { LOCATION } from '../../../types';

export default function ProtectedRoute(props) {
    const { location } = props;


    if (isLoggedIn()) {
        return <Route {...props} />
    }

    const { pathname } = location;
    let urlParam = '';

    if (pathname) {
        urlParam = `?redirect=${pathname}`;
    }

    // We can't use <Redirect> here because the micro-services
    // setup breaks React Router and would result in a bear page
    window.location.assign(`/log-in${urlParam}`);

    return null;
}

ProtectedRoute.propTypes = {
    location: LOCATION,
    isInternal: PropTypes.bool
};

ProtectedRoute.defaultProps = {
    isInternal: false
};